module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/rowhouse-238a6a89ad11343d7ba21c8ad6c8ab2e.png";